export const CONNECT_REQUEST = "CONNECT_REQUEST";
export const CONNECT_SUCCESS = "CONNECT_SUCCESS";
export const RECONNECT = "RECONNECT";
export const CONNECT_FAILURE = "CONNECT_FAILURE";

export const SOCKET_OPEN = "SOCKET_OPEN";
export const SOCKET_CLOSE = "SOCKET_CLOSE";
export const SOCKET_ERROR = "SOCKET_ERROR";
export const SOCKET_MESSAGE = "SOCKET_MESSAGE";
export const SOCKET_BOOK_MESSAGE = "SOCKET_BOOK_MESSAGE";
export const SOCKET_TRADES_MESSAGE = "SOCKET_TRADES_MESSAGE";

export const SUBSCRIBE_TO_CHANNEL = "SUBSCRIBE_TO_CHANNEL";
export const UNSUBSCRIBE_FROM_CHANNEL = "UNSUBSCRIBE_FROM_CHANNEL";
